import { compile as baseTemplateComplier } from '@syncfusion/ej2-base';
import { DrawingElement } from '@syncfusion/ej2-drawings';
/**
 * HTMLElement defines the basic html elements
 */
export class DiagramHtmlElement extends DrawingElement {
    /**
     * set the id for each element
     *
     * @param {string} nodeTemplate - Set the id for each element.
     * @returns {void}
     *
     * @private
     */
    constructor(nodeTemplate) {
        super();
        this.templateFn = this.templateCompiler(nodeTemplate);
    }
    templateCompiler(template) {
        if (template) {
            try {
                if (typeof template !== 'function' && document.querySelectorAll(template).length) {
                    return baseTemplateComplier(document.querySelector(template).innerHTML.trim());
                }
                else {
                    return baseTemplateComplier(template);
                }
            }
            catch (e) {
                return baseTemplateComplier(template);
            }
        }
        return undefined;
    }
    /**
     * getNodeTemplate method \
     *
     * @returns { Function } getNodeTemplate method .\
     *
     * @private
     */
    getNodeTemplate() {
        return this.templateFn;
    }
}
